var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blocks"},[(_vm.ready && !_vm.firstUpdate)?_c('admin-blocks',{attrs:{"blocks":_vm.blocks,"links":_vm.blocksLinks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }